import { findGroup, findQuery, randomId } from '../../reducers/util';

export const _addGroup = (study, queryId) => {
    const query = findQuery(study, queryId)
    const id = randomId()
    query.groups.push({
        id: id,
        title: 'Event ' + query.groups.length,
        criteria: [],
        operator: ['and']
    })
    updateIndexGroup(query)
    return id
}

export const _deleteGroup = (study, action) => {
    const query = findQuery(study, action.queryId)
    query.groups = query.groups.filter(i => i.id !== action.groupId)
    updateIndexGroup(query)
}

export const _copyGroup = (study, action) => {
    const { query, group } = findGroup(study, action.queryId, action.groupId)
    var newGroup = Object.assign({}, group, { id: randomId() })
    newGroup.criteria.forEach(i => i.id = randomId())
    newGroup.title = 'Copy of ' + newGroup.title
    newGroup.index = false
    query.groups.push(newGroup)
    updateIndexGroup(query)
}

export const setOperatorOfGroup = (study, action) => {
    const { query, group } = findGroup(study, action.queryId, action.groupId)
    group.operator = action.value
    updateIndexGroup(query)
}

export const updateIndexGroup = (query) => {
    query.groups.forEach(i => {
        i.index = false
    })
    if (query.groups.length > 0) {
        query.groups[0].index = true
    }
}

export const _setGroupTitle = (study, action) => {
    const { group } = findGroup(study, action.queryId, action.groupId)
    group.title = action.title
}